import player from "./player";
import axios, { AxiosResponse } from "axios";

import { pianoHost } from "./paths";
import { showNotification } from "./store/notification/actions";
const soundContainer: AudioBuffer[] = [];

class Piano {
    totalTry = 0;
    sources: AudioBufferSourceNode[] = [];
    gains: AudioParam[] = [];
    load = (num: number, playOnLoad?: boolean, options?: { stop?: number, start?: number | null }) => {
        if (!process.env.WEBPACK) return;
        if (soundContainer[num]) return true;
        return new Promise(resolve => {
            axios({
                method: "get",
                url: pianoHost + "piano/" + num + ".mp3",
                responseType: "arraybuffer",
            })
                .then(async (res: AxiosResponse<ArrayBuffer>) => {
                    if (res.data) {
                        await this.makeLoop(res.data, num, playOnLoad, options);
                        resolve(true);
                    } else {
                        resolve(false);
                        this.totalTry++;
                        if (this.totalTry < 10) {
                            setTimeout(() => {
                                this.load(num, playOnLoad, options);
                            }, 1000);
                        }
                        if (this.totalTry === 1) {
                            window.store.dispatch(showNotification("Error while loading audio file.", "warning"));
                        }
                    }
                })
                .catch(err => {
                    resolve(false);
                    this.totalTry++;
                    if (this.totalTry < 10) {
                        setTimeout(() => {
                            this.load(num, playOnLoad, options);
                        }, 1000);
                    }
                    if (this.totalTry === 1) {
                        window.store.dispatch(showNotification("Error while loading audio file.", "warning"));
                    }
                });
        });
    };
    play = async (notePlayed: number | "piano" | "slap" | null, start: null | number, stop: number, isBeat?: boolean) => {
        if (!process.env.WEBPACK) return;
        if (notePlayed !== "piano" && notePlayed !== "slap" && notePlayed !== null && !soundContainer[notePlayed]) {
            return this.load(notePlayed, true, { start, stop });
        }
        let buffer =
            notePlayed === "slap"
                ? player.slap!.buffer
                : notePlayed === "piano"
                    ? soundContainer[69]
                    : notePlayed
                        ? soundContainer[notePlayed]
                        : player.slap!.buffer;
        const source = player.context.createBufferSource();
        const gainNode = player.context.createGain();
        source.buffer = buffer;
        source.connect(gainNode);
        gainNode.connect(player.context.destination);
        gainNode.gain.value = isBeat ? 2.2 : 1.7;
        let deadline = start || player.context.currentTime;
        const maxStop = Math.min(stop, 2.88);
        gainNode.gain.setValueAtTime(2, deadline + maxStop);
        gainNode.gain.linearRampToValueAtTime(0, deadline + maxStop + 0.12);
        this.sources.push(source);
        source.start(deadline);
        this.gains.push(gainNode.gain);
    };

    stop = () => {
        this.sources.forEach(source => {
            source.stop(player.context.currentTime + 0.3);
        });
        this.gains.forEach(gain => {
            gain.linearRampToValueAtTime(0, player.context.currentTime + 0.2);
        });
        this.sources = [];
        this.gains = [];
    };
    schedule = (
        time: number,
        notes: {
            time: number;
            note: number | number[] | null | "slap" | "piano";
            duration: number;
            isBeat?: boolean | undefined;
        }[]
    ) => {
        if (!process.env.WEBPACK) return;
        notes.forEach((el, i) => {
            if (Array.isArray(el.note)) {
                el.note.forEach(note => {
                    this.play(note, time + el.time, el.duration, el.isBeat);
                });
            } else {
                this.play(el.note, time + el.time, el.duration, el.isBeat);
            }
        });
    };
    makeLoop = (arrayBuffer: ArrayBuffer, num: number, playOnLoad?: boolean, options?: { stop?: number, start?: number | null }) => {
        return new Promise(resolve => {
            if (soundContainer[num]) {
                resolve(true);
                return;
            }
            player.context.decodeAudioData(arrayBuffer, buffer => {
                soundContainer[num] = buffer;
                resolve(true);
                if (playOnLoad) {
                    this.play(num, options!.start!, options!.stop!);
                }
            });
        });
    };

    loadTrebleNodes = () => {
        for (let n = 53; n < 87; n++) {
            this.load(n);
        }
    };
}

export default new Piano();
